<div class="tw-size-16 tw-rounded-full main-background-color d-flex justify-content-center align-items-center">
  <i class="bi bi-plus-lg text-white tw-text-3xl"></i>
</div>
